import { Component, Input, OnDestroy, OnInit, TemplateRef, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BrowserDataService } from 'src/app/services/browser-data.service';
import { Router } from '@angular/router';
import { WebTestingService } from 'src/app/services/webtesting.service';

import { ActivatedRoute } from '@angular/router';
import html2canvas from 'html2canvas';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import io, { Socket } from 'socket.io-client';
import { CommonService } from 'src/app/services/common.service';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

declare const ImageCapture: any;


@Component({
    selector: 'app-web-screen',
    templateUrl: './web-screen.component.html',
    styleUrls: ['./web-screen.component.css'],
    standalone: true,
    imports: [TranslateModule, FormsModule]
})
export class WebScreenComponent implements OnInit, OnDestroy {
  // isPaused = false;
  private baseUrl: any = environment.baseUrl;
  private baseUrlBrowser: any = environment.baseUrlBrowser;
  modalRef!: MatDialogRef<any>;
  @ViewChild('alerttemplate') alertTemplate!: TemplateRef<any>;
  @ViewChild('myIframe') myIframe: ElementRef;
  @Input() dataItem: any;
  id: string = "";
  msg: string = "";
  userObj: any = {};
  browserDetails: any[] = [];
  isRecording: boolean = false;
  private subscription: Subscription;
  private mediaRecorder!: MediaRecorder;
  private recordedChunks: Blob[] = [];
  private stream!: MediaStream;
  @ViewChild('videoFrame', { static: true }) videoFrame!: ElementRef<HTMLIFrameElement>;
  private drawingInterval: number | null = null;
  isPaused: boolean = false;
  // userObj: any;
  item: any;
  trustedUrl: SafeResourceUrl | null = null;
  wsBrowserUpdates: Socket;
  domainUrl: string;


  constructor(
    private dialog: MatDialog,
    private http: HttpClient,
    private webTestingService: WebTestingService,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private dataService: BrowserDataService,
    private router: Router,
    private commonService: CommonService
  ) { }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    //getting the browser id
    this.route.params.subscribe(params => {
      this.id = params['id'];
    });
    //check for browser socket connection status
    if (!this.dataService.getBrowserSocketConnectionStatus()) {
      this.domainUrl = window.location.href;
      this.domainUrl = this.dataService.getBaseUrl(this.domainUrl);
      this.wsBrowserUpdates = io(this.domainUrl, {
        path: '/nbrowser/socket.io',  // Changed from '/socket.io' to '/nbrowser/socket.io/'
        reconnection: false,
        transports: ['websocket'],
        withCredentials: true
      });

      this.dataService.setBrowserSocketConnectionStatus(true);
      this.dataService.setSocketInstance(this.wsBrowserUpdates); // Store in service
      let user = JSON.parse(localStorage.getItem('currentUser'));
      this.wsBrowserUpdates.on('browsers_out', (data: any) => {
        if (this.id === data.id && data.action === 'released') { //if the acquired browser is released by admin
          this.browserDetails = JSON.parse(data.browsers);
          if (data.mail == "admin@apmosys.com") {
            this.msg = "Admin has released the browser!";
            this.openAlertMod(this.alertTemplate, this.msg);
          }
          // Navigate to browser page after 2 seconds
          setTimeout(() => {
            this.commonService.setActiveTab('/browser');
            this.router.navigate(['/browser']);
          }, 2000);
        } else if (this.id != null && this.id != data.id && data.action === 'acquired' && user.email === data.mail) { //if user has already has a browser and requests another one
          this.browserDetails = JSON.parse(data.browsers);
          let user: any = localStorage.getItem('currentUser');
          user = JSON.parse(user);
          this.dataService.updateUserStatusToFalse(user.userObj).subscribe({
            next: (response) => {
              //update the socket about the browser released
              let browserData = {
                "mail": user.email,
                "id": user.userObj.browsersAcquired,
                "action": "released"
              }
              this.wsBrowserUpdates.emit('browsers_in', browserData);
            },
            error: (error) => {
              console.error('Error:', error);
            },
          });
          user.userObj.browsersAcquired = null;
          localStorage.setItem('currentUser', JSON.stringify(user));
        } else {
          this.browserDetails = JSON.parse(data.browsers);
        }
        console.log('Parent - Browser update received:', data);
        // this.formatBrowserDetails();
        // this.segregateBrowsers();
      });
    } else {
      let user = JSON.parse(localStorage.getItem('currentUser'));
      this.wsBrowserUpdates = this.dataService.getSocketInstance(); // Retrieve from service
      this.wsBrowserUpdates.on('browsers_out', (data: any) => {
        if (this.id === data.id && data.action === 'released') {
          this.browserDetails = JSON.parse(data.browsers);
          if (data.mail == "admin@apmosys.com") {
            this.msg = "Admin has released the browser!";
            this.openAlertMod(this.alertTemplate, this.msg);
          }
          // Navigate to browser page after 2 seconds
          setTimeout(() => {
            this.commonService.setActiveTab('/browser');
            this.router.navigate(['/browser']);
          }, 2000);
        } else if (this.id != null && this.id != data.id && data.action === 'acquired' && user.email === data.mail) { //if user has already has a browser and requests another one
          this.browserDetails = JSON.parse(data.browsers);
          let user: any = localStorage.getItem('currentUser');
          user = JSON.parse(user);
          this.dataService.updateUserStatusToFalse(user.userObj).subscribe({
            next: (response) => {
              //update the socket about the browser released
              let browserData = {
                "mail": user.email,
                "id": user.userObj.browsersAcquired,
                "action": "released"
              }
              this.wsBrowserUpdates.emit('browsers_in', browserData);
            },
            error: (error) => {
              console.error('Error:', error);
            },
          });
          user.userObj.browsersAcquired = null;
          localStorage.setItem('currentUser', JSON.stringify(user));
        } else {
          this.browserDetails = JSON.parse(data.browsers);
        }
        console.log('Parent - Browser update received:', data);
        // this.formatBrowserDetails();
        // this.segregateBrowsers();
      });
    }

    // Initialize the iframe reference
    this.route.params.subscribe(params => {
      const id = params['id'];
      let user = JSON.parse(localStorage.getItem('currentUser'))
      const group = user.userObj.group;
      if (id) {
        // Fetching the browserDetails list from Python
        this.dataService.getBrowserList(group).subscribe({
          next: (response) => {
            this.browserDetails = response; // Handle successful response

            // Now that we have browserDetails, continue with the next API call
            let user: any = localStorage.getItem('currentUser');
            if (user) {
              user = JSON.parse(user);
              let data = {
                email: user.email,
                browserId: id
              };

              // Ensure browserDetails are available before making the post request
              if (this.browserDetails?.length > 0) {
                //update the socket about the browser acquisition
                let browserData = {
                  "mail": user.email,
                  "id": id,
                  "action": "acquired"
                }
                console.log('browserData', browserData, 'user', user, 'id', id);

                this.wsBrowserUpdates.emit('browsers_in', browserData);
                // Call the Node API after browserDetails are fetched
                this.http.post(`${this.baseUrl}/api/v1/browsersAcquired`, data).subscribe({
                  next: (response: any) => {
                    if (response.success) {
                      this.item = this.browserDetails.find(item => item.id === id);
                      if (this.item) {
                        this.userObj.mail = user.email;
                        this.userObj.id = id;
                        //updating browsersAcquired header of currentUser for routing
                        user.userObj.browsersAcquired = id;
                        localStorage.setItem('currentUser', JSON.stringify(user));
                        this.Launch(this.item, this.userObj);
                      } else {
                        console.error('Item not found for the given id');
                        // Optionally show a user-friendly message
                      }
                    } else {
                      if (response?.browserId) {
                        this.item = this.browserDetails.find(item => item.id === id);
                        if (this.item) {
                          this.userObj.mail = user.email;
                          this.userObj.id = this.item.id;
                          //updating browsersAcquired header of currentUser for routing
                          user.userObj.browsersAcquired = id;
                          localStorage.setItem('currentUser', JSON.stringify(user));
                          this.Launch(this.item, this.userObj);
                        } else {
                          console.error('Item not found for the given browserId');
                        }
                      } else {
                        this.msg = response.message;
                        this.openAlertMod(this.alertTemplate, this.msg);
                      }
                    }
                  },
                  error: (error) => {
                    console.error('Error with browsersAcquired API:', error);
                    // Optional: Add user feedback for request failure
                  }
                });
              } else {
                console.error('Browser details are not yet available');
                // Optionally show a user-friendly message
              }
            } else {
              console.error('User data not found in localStorage');
              // Handle missing user data if necessary
            }
          },
          error: (error) => {
            console.error('Error fetching browser list:', error);
            // Optional: Add user feedback for fetching failure
          }
        });
      }
    });


  }


  Launch(item: any, userObj: any) {
    if (!item || !userObj) return null;
    this.userObj = userObj;
    this.item = item;

    let url = item.accessUrl;
    if (url) {


      this.trustedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      // this.onIframeLoad();


      this.dataService.updateUserStatus(userObj).subscribe({

        next: (response: any) => {

        },
        error: (error) => {
          console.error('Error:', error);
        },
      });
    } else {
      this.trustedUrl = null;
    }
  }

  closeIframe() {
    this.dataService.updateUserStatusToFalse(this.userObj).subscribe({
      next: (response) => {
        //update the socket about the browser released
        let browserData = {
          "mail": this.userObj.mail,
          "id": this.userObj.id,
          "action": "released"
        }
        this.wsBrowserUpdates.emit('browsers_in', browserData);
        //call for node api to check the userObj
        let user: any = localStorage.getItem('currentUser');
        user = JSON.parse(user);
        let data = {
          'email': user.email,
          'browserId': null
        }
        this.http.post(`${this.baseUrl}` + '/api/v1/browsersAcquired', data).subscribe((response: any) => {
          if (response.success) {
            user.userObj.browsersAcquired = null;
            localStorage.setItem('currentUser', JSON.stringify(user));
            this.commonService.setActiveTab('/browser');
            this.router.navigate(['/browser']);
          }
        })
        this.webTestingService.triggerFormatDetails();
      },
      error: (error) => {
        console.error('Error:', error);
      },
    });
  }

  // takeScreenshot() {
  //   const element = document.querySelector('.WholeScreen') as HTMLElement;
  //   if (element) {
  //     html2canvas(element, { useCORS: true }).then((canvas) => {
  //       const screenshotData = canvas.toDataURL('image/png'); // Convert canvas to image
  //       this.downloadScreenshot(screenshotData); // Save the image
  //     });
  //   } else {
  //     console.error('Screenshot container not found');
  //   }
  // }

  //new
  async takeScreenshot() {
    try {
      // Prompt user to select the screen/tab containing the VNC session
      const stream = await (navigator.mediaDevices as any).getDisplayMedia({
        video: { mediaSource: 'screen' },
        preferCurrentTab: true  // Chrome 107+ hints to capture current tab
      });

      const track = stream.getVideoTracks()[0];
      const imagecapture = new ImageCapture(track);
      const bitmap = await imagecapture.grabFrame();

      // Draw to canvas and export
      const canvas = document.createElement('canvas');
      canvas.width = bitmap.width;
      canvas.height = bitmap.height;
      canvas.getContext('2d')!.drawImage(bitmap, 0, 0);

      this.downloadScreenshot(canvas.toDataURL('image/png'));

      // Stop the stream
      stream.getTracks().forEach((t: MediaStreamTrack) => t.stop());
    } catch (err) {
      console.error('Screenshot failed:', err);
    }
  }

  downloadScreenshot(imageData: string) {
    const link = document.createElement('a');
    link.href = imageData;
    link.download = `screenshot_${new Date().getTime()}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  // Swal.fire({
  //   title: 'Are you sure?',
  //   text: 'You won\'t be able to revert this!',
  //   icon: 'warning',
  //   showCancelButton: true,
  //   confirmButtonColor: '#3085d6',
  //   cancelButtonColor: '#d33',
  //   confirmButtonText: 'Save Screenshot'
  // }).then((result) => {
  //   if (result.isConfirmed) {
  //     Swal.fire('Deleted!', 'Your file has been deleted.', 'success');
  //   }
  // });

  // async  startRecording(){
  //   try {
  //     // this.stream = await navigator.mediaDevices.getDisplayMedia({
  //     //   video: { mediaSource: "screen" },
  //     //   audio: true
  //     // });
  //     this.stream = await navigator.mediaDevices.getDisplayMedia({
  //       video: true,
  //       audio: true
  //     });

  //     this.mediaRecorder = new MediaRecorder(this.stream);
  //     this.mediaRecorder.ondataavailable = (event) => {
  //       if (event.data.size > 0) {
  //         this.recordedChunks.push(event.data);
  //       }
  //     };

  //     this.mediaRecorder.onstop = () => this.saveRecording();

  //     this.mediaRecorder.start();
  //     this.isRecording = true;
  //     this.isPaused = false;
  //   } catch (error) {
  //     console.error("Error starting recording:", error);
  //   }    }

  toggleRecord() {
    if (this.mediaRecorder) {
      if (this.isPaused) {
        this.mediaRecorder.resume();
      } else {
        this.mediaRecorder.pause();
      }
      this.isPaused = !this.isPaused;
    }
  }

  stopRecording() {
    if (this.mediaRecorder) {
      this.mediaRecorder.stop();

      // Stop the canvas stream tracks
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop());
      }

      // Clear the drawing interval
      if (this.drawingInterval) {
        window.clearInterval(this.drawingInterval);
        this.drawingInterval = null;
      }

      this.isRecording = false;
      this.isPaused = false;
    }
  }

  private saveRecording() {
    const blob = new Blob(this.recordedChunks, { type: "video/webm" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "screen-recording.webm";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // Clean up
    URL.revokeObjectURL(url);
    this.recordedChunks = [];
  }

  // async startRecording() {
  //   // Use your existing iframe reference
  //   const iframe = this.myIframe.nativeElement;
  //   if (!iframe) {
  //     console.error("Iframe not found!");
  //     return;
  //   }

  //   const canvas = document.createElement("canvas");
  //   const ctx = canvas.getContext("2d");

  //   if (!ctx) {
  //     console.error("Canvas context not supported!");
  //     return;
  //   }

  //   // Set canvas dimensions to match iframe
  //   canvas.width = iframe.offsetWidth || 800;
  //   canvas.height = iframe.offsetHeight || 600;

  //   // Get canvas stream
  //   this.stream = canvas.captureStream(30); // Capture at 30 FPS
  //   this.mediaRecorder = new MediaRecorder(this.stream);

  //   // Reset recorded chunks
  //   this.recordedChunks = [];

  //   this.mediaRecorder.ondataavailable = (event) => {
  //     if (event.data.size > 0) {
  //       this.recordedChunks.push(event.data);
  //     }
  //   };

  //   this.mediaRecorder.onstop = () => {
  //     this.saveRecording();
  //   };

  //   // Start recording
  //   this.mediaRecorder.start();
  //   this.isRecording = true;
  //   this.isPaused = false;

  //   // Draw the iframe to canvas at regular intervals
  //   this.drawingInterval = window.setInterval(() => {
  //     try {
  //       // Try to access iframe content since you already have access in onIframeLoad
  //       const iframeDocument = iframe.contentDocument || iframe.contentWindow?.document;
  //       if (iframeDocument && iframeDocument.body) {
  //         // If we have access to iframe content, try to capture it
  //         ctx.fillStyle = "#000000";
  //         ctx.fillRect(0, 0, canvas.width, canvas.height);
  //         ctx.fillStyle = "#ffffff";
  //         ctx.font = "16px Arial";
  //         ctx.fillText("Recording VNC Session...", 10, 30);
  //       } else {
  //         // Draw placeholder if we can't access iframe content
  //         ctx.fillStyle = "#000000";
  //         ctx.fillRect(0, 0, canvas.width, canvas.height);
  //         ctx.fillStyle = "#ffffff";
  //         ctx.font = "16px Arial";
  //         ctx.fillText("Recording in progress...", 10, 30);
  //       }
  //     } catch (error) {
  //       // Draw placeholder on error
  //       ctx.fillStyle = "#000000";
  //       ctx.fillRect(0, 0, canvas.width, canvas.height);
  //       ctx.fillStyle = "#ffffff";
  //       ctx.font = "16px Arial";
  //       ctx.fillText("Recording...", 10, 30);
  //     }
  //   }, 1000 / 30); // 30 FPS
  // }

  //new
  async startRecording() {
    try {
      // Capture the actual screen/tab
      this.stream = await (navigator.mediaDevices as any).getDisplayMedia({
        video: { mediaSource: 'screen', frameRate: 30 },
        audio: false,
        preferCurrentTab: true
      });

      this.recordedChunks = [];
      this.mediaRecorder = new MediaRecorder(this.stream, {
        mimeType: 'video/webm;codecs=vp9'
      });

      this.mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) this.recordedChunks.push(event.data);
      };

      this.mediaRecorder.onstop = () => {
        // Stop all tracks when recording ends
        this.stream.getTracks().forEach((t: MediaStreamTrack) => t.stop());
        this.saveRecording();
      };

      // Handle user stopping share via browser UI
      this.stream.getVideoTracks()[0].onended = () => {
        if (this.isRecording) this.stopRecording();
      };

      this.mediaRecorder.start();
      this.isRecording = true;
      this.isPaused = false;

      // Remove the drawingInterval entirely — no longer needed
    } catch (err) {
      console.error('Recording failed:', err);
      this.isRecording = false;
    }
  }

  //automating the login process for the mac browser only.
  onIframeLoad() {
    const iframe = this.myIframe.nativeElement;
    const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
    const connectButton = iframeDocument.getElementById('noVNC_connect_button');
    if (connectButton) {
      connectButton.addEventListener('click', () => {
      });
      connectButton.click();
      setTimeout(() => {
        const usernameInput = iframeDocument.getElementById('noVNC_username_input');
        const passwordInput = iframeDocument.getElementById('noVNC_password_input');
        const send = iframeDocument.getElementById('noVNC_credentials_button');        // Check if the elements exist before setting their values
        if (usernameInput && passwordInput) {
          usernameInput.value = 'macmini3';
          passwordInput.value = 'Apmosys@123';
          send.click()
        } else {
          console.error('Form elements not found');
        }
      }, 2000)
    } else {
      console.error('Connect button not found inside the iframe.');
    }
  }

  openAlertMod(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
    setTimeout(() => {
      this.modalRef.close();;
      this.msg = "";
    }, 2000)
  }

  Ok() {
    this.modalRef.close();;
    this.msg = "";
  }
}

